import React, { useEffect, useState } from "react";

const YouTubePreview = ({
    previewOptions,
    setData,
    editMode = true,
    triggerResize,
}) => {
    const [isValid, setIsValid] = useState(true);
    const isPortrait = previewOptions.portrait;

    useEffect(() => {
        triggerResize?.(); // Trigger on mount
    }, []);

    useEffect(() => {
        const checkYouTubeVideo = async () => {
            try {
                const res = await fetch(
                    `https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${previewOptions.youtubeId}&format=json`,
                );
                setIsValid(res.ok);
            } catch {
                setIsValid(false);
            }
        };

        checkYouTubeVideo();
    }, [previewOptions.youtubeId]);

    if (!isValid) return null;

    return (
        <div
            id="embed-container"
            className={`mt-4 w-full ${isPortrait ? "flex justify-center" : ""} pb-4`}
        >
            <div
                className={`relative ${
                    isPortrait ? "" : "w-full pb-[56.25%] h-0"
                }`}
            >
                {/* Delete Button */}
                {editMode && (
                    <button
                        type="button"
                        onClick={() => setData("embed", null)}
                        className="absolute -top-3 -left-3 z-10 w-6 h-6 bg-red text-white text-xs rounded-full flex items-center justify-center shadow hover:bg-red-600"
                    >
                        ✕
                    </button>
                )}

                {isPortrait ? (
                    <iframe
                        className="rounded-[15px]"
                        title="embed"
                        width="390"
                        height="692"
                        src={`https://www.youtube.com/embed/${previewOptions.youtubeId}`}
                        allowFullScreen
                    ></iframe>
                ) : (
                    <iframe
                        className="absolute top-0 left-0 w-full h-full rounded-[15px]"
                        title="embed"
                        src={`https://www.youtube.com/embed/${previewOptions.youtubeId}`}
                        allowFullScreen
                    ></iframe>
                )}
            </div>
        </div>
    );
};

export default YouTubePreview;
